export const SCOPED_LABEL_DELIMITER = '::';
export const DEBOUNCE_DROPDOWN_DELAY = 200;

export const DropdownVariant = {
  Sidebar: 'sidebar',
  Standalone: 'standalone',
  Embedded: 'embedded',
};

export const LabelType = {
  group: 'group',
  project: 'project',
};
